import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as common from '../../../common'
import type { Entity } from '../../types'

export const DOC = gql`
  ${common.gql.mappings.fragments.mapping.DOC}
  ${common.gql.filters.fragments.filter.DOC}
  fragment FragmentRateRule on RateRule {
    id
    name
    priority
    isActive
    mapping {
      ...FragmentRateMapping
    }
    filter {
      ...FragmentGeneralLedgerFilter
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentRateRuleFragment,
  Entity
>({
  filter: graphql.transformers.OUT.default(
    common.gql.filters.fragments.filter.TRANSFORMER,
    ents.extra.rate.gl.Filter.DEFAULT,
  ),
  id: transformers.PASS_THROUGH,
  isActive: graphql.transformers.OUT.default(transformers.PASS_THROUGH, true),
  mapping: graphql.transformers.OUT.default(
    common.gql.mappings.fragments.mapping.TRANSFORMER,
    { entries: [] },
  ),
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  priority: graphql.transformers.OUT.default(transformers.PASS_THROUGH, 999),
})
